import React from 'react';
import CalendarFilters from './Calendar.filters';
import EventsCalendar from './Calendar.calendar';
import { EventsByDay, EventTypeFilter } from '../types';

export const CalendarSection: React.FC<{
  events: EventsByDay;
  maxDate: string;
  minDate: string;
  currentDate: string;
  handleDateChange: (date: string) => void;
  isLoading: boolean;
  selectedEventType: EventTypeFilter[];
  onSelectEventType: (events: EventTypeFilter[]) => void;
  onSelectVendors: (vendors: string[]) => void;
  vendors: { name: string; id: string }[];
  handleSelectDate: (date: string) => void;
  selectedDate: string;
  isRefetching: boolean;
}> = ({
  events,
  maxDate,
  minDate,
  currentDate,
  handleDateChange,
  isLoading,
  selectedEventType,
  onSelectEventType,
  onSelectVendors,
  vendors,
  handleSelectDate,
  selectedDate,
  isRefetching,
}) => {
  return (
    <>
      <CalendarFilters
        selectedEventType={selectedEventType}
        onSelectEventType={onSelectEventType}
        onSelectVendors={onSelectVendors}
        vendors={vendors}
      />
      <EventsCalendar
        isLoading={isLoading}
        isRefetching={isRefetching}
        events={events}
        maxDate={maxDate}
        minDate={minDate}
        currentDate={currentDate}
        handleDateChange={handleDateChange}
        handleSelectDate={handleSelectDate}
        selectedDate={selectedDate}
      />
    </>
  );
};
export default CalendarSection;
